import React, { Component } from "react";
import { ComboBox } from "../ComboBox";
import HistoryTaskComment from "./HistoryTaskComment";

export class AdminTaskDetail extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            data: null,
            taskId: props.taskId, //this.props.location.pathname.substring(this.props.location.pathname.lastIndexOf('/') + 1, this.props.location.pathname.length),
            history: null,
            isFinished: false,
            optionsState: []
        }
        this.save = this.save.bind(this);

        this.hideDate = this.hideDate.bind(this);
    }

    handleChange = event => {
        if (this.props.handlerCloseModal) {
            this.props.handlerCloseModal(event)
        }
    }

    hideDate(e) {
        alert();
    }

    componentDidMount() {

        setTimeout(() => {
            document.querySelector('#openDetailTask').click();
        }, 1000);
       
    }

    componentWillUnmount() {
        
    }

    componentWillMount() {
        if (this.state.taskId > 0) {
            this.getData();
        }
    }

    

    generateOptionState(data) {

        this.setState({ optionsState: [] });

        this.state.optionsState.push({ id: 'Nueva', value: 'Nueva' });
        this.state.optionsState.push({ id: 'En curso', value: 'En curso' });
        this.state.optionsState.push({ id: 'Finalizada', value: 'Finalizada' });
        this.state.optionsState.push({ id: 'Aplazada', value: 'Aplazada' });

        let admin = data.roles.find((a) => { return a == 'Administrador' })
        if (admin) {
            this.state.optionsState.push({ id: 'Aprobar', value: 'Aprobar' });
            this.state.optionsState.push({ id: 'Cerrar proceso', value: 'Cerrar proceso' });
        }

        let coordinator = data.roles.find((a) => { return a == 'Director' })
        if (coordinator) {
            this.state.optionsState.push({ id: 'Aprobar', value: 'Aprobar' });
        }
    }

    static RenderDetail(data, history, e) {
        let parent;
        if (data && data.taskDetail) {
            parent = data.taskDetail.idParent ? <div className="form-group"> <span> Depende de</ span> <span>{data.taskDetail.idParent}</span> </div> : <div></div>;
        }

        return (

            <div class="modal fade" id="modalDetailTask" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Detalle de la tarea</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={e.handleChange}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">


                            <div className="table">
                                <div className="form-group">
                                    <h4>{data.taskDetail.title}</h4>
                                </div>
                                <div className="form-group">
                                    <b>Descripción</b><br />
                                    <span>{data.taskDetail.description}</span>
                                </div>

                                <div className="form-group">
                                    <b>Sede: </b>
                                    <span>{data.taskDetail.sede}</span>
                                </div>
                                <div className="form-group">
                                    <b>Proceso: </b>
                                    <span>{data.taskDetail.process}</span>
                                </div>

                                <div className="form-group">
                                    <b>Informador: </b>
                                    <span>{data.taskDetail.informer}</span>
                                </div>
                                <div className="form-group">
                                    <b>Debe estar lista: </b>
                                    <span>{data.taskDetail.taskFinish}</span>
                                </div>

                                <label>Comentarios</label>
                                <HistoryTaskComment items={history} />

                                <div className="form-group">
                                    <label>* Cambiar estado</label>
                                    <ComboBox data={e.state.optionsState} id="comboWrappState" lot={false} selectedValue={data.taskDetail.condition} isRequired="true" callBack={(event) => {

                                        e.setState({ isFinished: event.currentTarget.value == 'Aplazada' })

                                    }} />

                                </div>

                                {e.state.isFinished ? <div className="form-group">
                                    <label>* Seleccione una nueva fecha y hora</label>
                                    <input type="datetime-local" className="form-control" name="finish" isRequired="true" />
                                </div> : null}



                                <div className="form-group">
                                    <textarea className="form-control"></textarea>
                                </div>
                                <div className="actions form-group">
                                    <input type="button" className="btn btn-primary" value="Guardar" onClick={e.save} />
                                    <a id="DetailRedirect" className="btn btn-primary" hidden>Editar</a>
                                </div>
                            </div>
                                

                            </div>
                            <div class="modal-footer">


                                <div id="plDeleteTask">
                                <input id="chkDelete" type="checkbox" onChange={(a) => {
                                    e.setState({ deleteTaskConfirm: a.currentTarget.checked });
                                    }} /> Deseo eliminar la tarea
                                <button id="btnDelete" type="button" class="btn btn-danger" disabled={!e.state.deleteTaskConfirm} onClick={(a) => {
                                    e.deleteTask(data.taskDetail.id);
                                    }}>Eliminar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
    }

    render() {
        let content = this.state.loading ? <h2>Cargando...</h2> : AdminTaskDetail.RenderDetail(this.state.data, this.state.history, this);

        return (
            <div>{content}</div>
        )
    }

    async getData() {
        const request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            }
        }

        const response = await fetch(`Task/Detail?id=${this.state.taskId}`, request);
        if (response.redirected) {
            window.location.href = response.url;
        }

        const data = await response.json();
        this.generateOptionState(data);
        this.setState({ loading: false, data: data, history: data.taskHistory });
    }

    async save() {

        if (!document.querySelector('#comboWrappState select').value || (document.querySelector('#comboWrappState select').value == 'Aplazada' && !document.querySelector('input[name=finish]').value)) {
            alert('Los campos marcados con asterisco (*) son obligatorios.');
            return;
        }

        let model = {
            Condition: document.querySelector('#comboWrappState select').value,
            Comment: document.querySelector('textarea').value,
            TaskId: parseInt(this.state.taskId),
            CreatedOnDate: document.querySelector('input[name=finish]') && document.querySelector('input[name=finish]').value ? document.querySelector('input[name=finish]').value : new Date()
        };

        const requestOption = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(model)
        };

        this.setState({ loading: true })

        const response = await fetch('Task/SaveHistoryTask', requestOption);
        if (response.redirected) {
            window.location.href = response.url;
        }
        else {
            //window.location.href = '/tareas';
        }
        this.getData();
        this.setState({ loading: false });
        document.querySelectorAll('.modal-backdrop').forEach(a => { a.remove() });
        document.querySelector('#openDetailTask').click();
    }

    async deleteTask(id) {
        this.setState({ deleteTaskConfirm: false });
        const request = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            }
            //body: JSON.stringify(model)
        }

        const response = await fetch(`Task/DeleteTask?id=${id}`, request);
        if (response.status == 200) {
            document.querySelector('.close').click();
        }
    }
}